module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Itingen-30327ace7cc9d248b204fc290ffe11cb.svg";